<script>
import { authComputed } from '@state/helpers'
import store from '@state/store'

export default {
  name: 'OrganizationInfoForm',
  props: {
    submitError: {
      type: String,
      required: true,
    },
    organizationData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      newPassword: '',
      confirmPassword: '',
      nonprofitName: '',
      profilePageName: '',
      mainWebsite: '',
      volunteerWebsite: '',
      missionStatement: '',
      causeId: '',
      city: '',
      state: '',
      zip: '',
      errors: {
        newPassword: '',
        confirmPassword: '',
        nonprofitName: '',
        profilePageName: '',
        mainWebsite: '',
        volunteerWebsite: '',
        missionStatement: '',
        causeId: '',
        city: '',
        state: '',
        zip: '',
      },
      showNewPassword: false,
      showConfirmPassword: false,
      showNonProfitNameField: false,
      showProfilePageNameField: false,
      showMainWebsiteField: false,
      showVolunteerWebsiteField: false,
      showMissionStatementField: false,
      causes: [],
      loadingCauses: false,
      states: [
        { code: 'AL', name: 'Alabama' },
        { code: 'AK', name: 'Alaska' },
        { code: 'AZ', name: 'Arizona' },
        { code: 'AR', name: 'Arkansas' },
        { code: 'CA', name: 'California' },
        { code: 'CO', name: 'Colorado' },
        { code: 'CT', name: 'Connecticut' },
        { code: 'DE', name: 'Delaware' },
        { code: 'FL', name: 'Florida' },
        { code: 'GA', name: 'Georgia' },
        { code: 'HI', name: 'Hawaii' },
        { code: 'ID', name: 'Idaho' },
        { code: 'IL', name: 'Illinois' },
        { code: 'IN', name: 'Indiana' },
        { code: 'IA', name: 'Iowa' },
        { code: 'KS', name: 'Kansas' },
        { code: 'KY', name: 'Kentucky' },
        { code: 'LA', name: 'Louisiana' },
        { code: 'ME', name: 'Maine' },
        { code: 'MD', name: 'Maryland' },
        { code: 'MA', name: 'Massachusetts' },
        { code: 'MI', name: 'Michigan' },
        { code: 'MN', name: 'Minnesota' },
        { code: 'MS', name: 'Mississippi' },
        { code: 'MO', name: 'Missouri' },
        { code: 'MT', name: 'Montana' },
        { code: 'NE', name: 'Nebraska' },
        { code: 'NV', name: 'Nevada' },
        { code: 'NH', name: 'New Hampshire' },
        { code: 'NJ', name: 'New Jersey' },
        { code: 'NM', name: 'New Mexico' },
        { code: 'NY', name: 'New York' },
        { code: 'NC', name: 'North Carolina' },
        { code: 'ND', name: 'North Dakota' },
        { code: 'OH', name: 'Ohio' },
        { code: 'OK', name: 'Oklahoma' },
        { code: 'OR', name: 'Oregon' },
        { code: 'PA', name: 'Pennsylvania' },
        { code: 'RI', name: 'Rhode Island' },
        { code: 'SC', name: 'South Carolina' },
        { code: 'SD', name: 'South Dakota' },
        { code: 'TN', name: 'Tennessee' },
        { code: 'TX', name: 'Texas' },
        { code: 'UT', name: 'Utah' },
        { code: 'VT', name: 'Vermont' },
        { code: 'VA', name: 'Virginia' },
        { code: 'WA', name: 'Washington' },
        { code: 'WV', name: 'West Virginia' },
        { code: 'WI', name: 'Wisconsin' },
        { code: 'WY', name: 'Wyoming' },
      ],
    }
  },
  computed: { ...authComputed },
  mounted() {
    this.fetchCauses()
    // Pre-populate form if organization data is provided
    if (this.organizationData) {
      this.nonprofitName = this.organizationData.nonprofit_name || ''
      this.profilePageName = this.organizationData.profile_page_name || ''
      this.mainWebsite = this.organizationData.main_website || ''
      this.volunteerWebsite = this.organizationData.volunteer_website || ''
      this.missionStatement = this.organizationData.mission_statement || ''
    }
  },
  methods: {
    submitInfoForm() {
      if (!this.newPassword) {
        this.errors.newPassword = 'Password required.'
      }
      if (!this.confirmPassword) {
        this.errors.confirmPassword = 'Confirm password required.'
      } else if (this.confirmPassword !== this.newPassword) {
        console.log('sdawda')
        this.errors.confirmPassword = 'Passwords do not match.'
      }
      if (!this.missionStatement) {
        this.errors.missionStatement = 'Mission statement required.'
        if (!this.showMissionStatementField) {
          this.toggleShowMissionStatementField()
        }
      }
      if (!this.nonprofitName) {
        this.errors.nonprofitName = 'Nonprofit name required.'
        if (!this.showNonProfitNameField) {
          this.toggleShowNonProfitNameField()
        }
      }
      if (!this.profilePageName) {
        this.errors.profilePageName = 'Profile page name required.'
        if (!this.showProfilePageNameField) {
          this.toggleShowProfilePageNameField()
        }
      }
      if (!this.mainWebsite) {
        this.errors.mainWebsite = 'Main website required.'
        if (!this.showMainWebsiteField) {
          this.toggleShowMainWebsiteField()
        }
      }
      if (!this.volunteerWebsite) {
        this.errors.volunteerWebsite = 'Volunteer website required.'
        if (!this.showVolunteerWebsiteField) {
          this.toggleShowVolunteerWebsiteField()
        }
      }
      // for when we have select options
      // if (!this.causeId) {
      //   this.errors.causeId = 'Cause area required.'
      // }
      if (!this.city) {
        this.errors.city = 'City required.'
      }
      // for when we have select options
      // if (!this.state) {
      //   this.errors.state = 'State required.'
      // }
      if (!this.zip) {
        this.errors.zip = 'Zip code required.'
      }
      if (!Object.values(this.errors).some((x) => x !== '')) {
        this.$emit('clear-submit-errors')
        this.$emit('post-submit', {
          newPassword: this.newPassword,
          confirmPassword: this.confirmPassword,
          nonprofitName: this.nonprofitName,
          profilePageName: this.profilePageName,
          mainWebsite: this.mainWebsite,
          volunteerWebsite: this.volunteerWebsite,
          missionStatement: this.missionStatement,
          causeId: this.causeId,
          city: this.city,
          state: this.state,
          zip: this.zip,
        })
      }
    },
    clearSubmitErrors(fieldName) {
      if (fieldName) {
        this.errors[fieldName] = ''
      }
      this.$emit('clear-submit-errors')
    },
    toggleShowNewPassword() {
      this.showNewPassword = !this.showNewPassword
    },
    toggleShowConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword
    },
    toggleShowNonProfitNameField() {
      this.showNonProfitNameField = !this.showNonProfitNameField
    },
    toggleShowProfilePageNameField() {
      this.showProfilePageNameField = !this.showProfilePageNameField
    },
    toggleShowMainWebsiteField() {
      this.showMainWebsiteField = !this.showMainWebsiteField
    },
    toggleShowVolunteerWebsiteField() {
      this.showVolunteerWebsiteField = !this.showVolunteerWebsiteField
    },
    toggleShowMissionStatementField() {
      this.showMissionStatementField = !this.showMissionStatementField
    },
    saveNonProfitField() {
      if (!this.nonprofitName) {
        this.errors.nonprofitName = 'Nonprofit name required.'
        return
      }
      this.toggleShowNonProfitNameField()
    },
    saveProfilePageField() {
      if (!this.profilePageName) {
        this.errors.profilePageName = 'Profle page name required.'
        return
      }
      this.toggleShowProfilePageNameField()
    },
    saveMainWebsiteField() {
      if (!this.mainWebsite) {
        this.errors.mainWebsite = 'Main website required.'
        return
      }
      this.toggleShowMainWebsiteField()
    },
    saveVolunteerWebsiteField() {
      if (!this.volunteerWebsite) {
        this.errors.volunteerWebsite = 'Volunteer website required.'
        return
      }
      this.toggleShowVolunteerWebsiteField()
    },
    saveMissionStatementField() {
      if (!this.missionStatement) {
        this.errors.missionStatement = 'Mission statement required.'
        return
      }
      this.toggleShowMissionStatementField()
    },
    fetchCauses() {
      this.loadingCauses = true
      store
        .dispatch('companies/fetchCauses')
        .then(({ data }) => {
          if (data) {
            this.causes = data
          }
        })
        .catch((error) => {
          console.error('Failed to fetch causes:', error)
        })
        .finally(() => {
          this.loadingCauses = false
        })
    },
  },
}
</script>

<template>
  <div class="">
    <div class="flex items-center mt-8 -mx-2">
      <div class="flex items-center gap-3">
        <p
          class="rounded-full text-center bg-blue text-white"
          style="line-height: 35px; width: 35px"
          >1</p
        >
        <span class="text-blue">Info</span>
      </div>
      <div class="h-2px w-2/5 bg-gray ml-4 mr-4"></div>
      <div class="flex items-center gap-3">
        <p
          class="rounded-full text-center bg-transparent border-gray border-solid border-2 text-gray"
          style="line-height: 35px; width: 40px"
          >2</p
        >
        <span class="text-gray">Social</span>
      </div>
      <div class="h-2px w-2/5 bg-gray ml-4 mr-4"></div>
      <div class="flex items-center gap-3">
        <p
          class="rounded-full text-center bg-transparent border-gray border-solid border-2 text-gray"
          style="line-height: 35px; width: 40px"
          >3</p
        >
        <span class="text-gray">Admins</span>
      </div>
    </div>
    <div class="text-left">
      <fieldset class="mt-8 flex -mx-2">
        <legend class="mb-3 text-gray">Create a Password:</legend>
        <div class="w-1/2 pr-4 relative">
          <input
            v-model="newPassword"
            :type="showNewPassword ? 'text' : 'password'"
            name="password"
            class="input"
            placeholder="Password"
            :class="[errors.newPassword !== '' ? 'border-red' : '']"
            @input="clearSubmitErrors('newPassword')"
          />
          <button
            class="focus:outline-none mt-2.5 -ml-8 absolute"
            @click="toggleShowNewPassword"
          >
            <svg
              v-show="showNewPassword"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#069bd7"
              width="17.433"
              height="15.57"
            >
              <path
                d="M1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12ZM12.0003 17C14.7617 17 17.0003 14.7614 17.0003 12C17.0003 9.23858 14.7617 7 12.0003 7C9.23884 7 7.00026 9.23858 7.00026 12C7.00026 14.7614 9.23884 17 12.0003 17ZM12.0003 15C10.3434 15 9.00026 13.6569 9.00026 12C9.00026 10.3431 10.3434 9 12.0003 9C13.6571 9 15.0003 10.3431 15.0003 12C15.0003 13.6569 13.6571 15 12.0003 15Z"
              ></path>
            </svg>
            <svg
              v-show="!showNewPassword"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#069bd7"
              width="17.433"
              height="15.57"
            >
              <path
                d="M4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457ZM14.7577 16.1718L13.2937 14.7078C12.902 14.8952 12.4634 15.0002 12.0003 15.0002C10.3434 15.0002 9.00026 13.657 9.00026 12.0002C9.00026 11.537 9.10522 11.0984 9.29263 10.7067L7.82866 9.24277C7.30514 10.0332 7.00026 10.9811 7.00026 12.0002C7.00026 14.7616 9.23884 17.0002 12.0003 17.0002C13.0193 17.0002 13.9672 16.6953 14.7577 16.1718ZM7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925L16.947 12.7327C16.9821 12.4936 17.0003 12.249 17.0003 12.0002C17.0003 9.23873 14.7617 7.00016 12.0003 7.00016C11.7514 7.00016 11.5068 7.01833 11.2677 7.05343L7.97446 3.76015Z"
              ></path>
            </svg>
          </button>
          <span
            v-if="errors.newPassword !== ''"
            class="right-0 absolute mr-4 text-red text-xxs capitalize text-right block w-full"
            >{{ errors.newPassword }}
          </span>
        </div>
        <div class="w-1/2 pl-4 relative">
          <input
            v-model="confirmPassword"
            :type="showConfirmPassword ? 'text' : 'password'"
            name="confirm-password"
            class="input"
            placeholder="Confirm Password"
            :class="[errors.confirmPassword !== '' ? 'border-red' : '']"
            @input="clearSubmitErrors('confirmPassword')"
          />
          <button
            class="focus:outline-none mt-2.5 -ml-8 absolute"
            @click="toggleShowConfirmPassword"
          >
            <svg
              v-show="showConfirmPassword"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#069bd7"
              width="17.433"
              height="15.57"
            >
              <path
                d="M1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12ZM12.0003 17C14.7617 17 17.0003 14.7614 17.0003 12C17.0003 9.23858 14.7617 7 12.0003 7C9.23884 7 7.00026 9.23858 7.00026 12C7.00026 14.7614 9.23884 17 12.0003 17ZM12.0003 15C10.3434 15 9.00026 13.6569 9.00026 12C9.00026 10.3431 10.3434 9 12.0003 9C13.6571 9 15.0003 10.3431 15.0003 12C15.0003 13.6569 13.6571 15 12.0003 15Z"
              ></path>
            </svg>
            <svg
              v-show="!showConfirmPassword"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#069bd7"
              width="17.433"
              height="15.57"
            >
              <path
                d="M4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457ZM14.7577 16.1718L13.2937 14.7078C12.902 14.8952 12.4634 15.0002 12.0003 15.0002C10.3434 15.0002 9.00026 13.657 9.00026 12.0002C9.00026 11.537 9.10522 11.0984 9.29263 10.7067L7.82866 9.24277C7.30514 10.0332 7.00026 10.9811 7.00026 12.0002C7.00026 14.7616 9.23884 17.0002 12.0003 17.0002C13.0193 17.0002 13.9672 16.6953 14.7577 16.1718ZM7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925L16.947 12.7327C16.9821 12.4936 17.0003 12.249 17.0003 12.0002C17.0003 9.23873 14.7617 7.00016 12.0003 7.00016C11.7514 7.00016 11.5068 7.01833 11.2677 7.05343L7.97446 3.76015Z"
              ></path>
            </svg>
          </button>
          <span
            v-if="errors.confirmPassword !== ''"
            class="right-0 absolute mr-4 text-red text-xxs capitalize text-right block w-full"
            >{{ errors.confirmPassword }}
          </span>
        </div>
      </fieldset>
    </div>
    <div class="flex -mx-2 mt-8 gap-10 text-left">
      <div class="flex flex-col items-start w-1/2">
        <div class="flex gap-3 justify-center mb-2">
          <label class="text-gray">Non Profit Name: </label>
          <button
            v-show="!showNonProfitNameField"
            class="text-blue"
            @click="toggleShowNonProfitNameField"
            >Edit</button
          >
          <button
            v-show="showNonProfitNameField"
            class="text-blue"
            @click="saveNonProfitField"
            >Save</button
          >
        </div>
        <span
          v-show="!showNonProfitNameField"
          class="text-left font-semibold"
          >{{ nonprofitName === '' ? 'Legal Name' : nonprofitName }}</span
        >
        <div v-show="showNonProfitNameField" class="w-full relative">
          <input
            v-model="nonprofitName"
            type="text"
            name="nonprofit-name"
            placeholder="Nonprofit Name"
            class="input"
            :class="[errors.nonprofitName !== '' ? 'border-red' : '']"
            @input="clearSubmitErrors('nonprofitName')"
          />
          <svg
            v-if="errors.nonprofitName !== ''"
            class="absolute right-0 top-0 mr-3 mt-2.5"
            xmlns="http://www.w3.org/2000/svg"
            width="17.433"
            height="15.57"
            viewBox="0 0 17.433 15.57"
          >
            <path
              class="a"
              fill="red"
              d="M19.066,17.847,12.211,5.978h0a1.808,1.808,0,0,0-.342-.483,1.772,1.772,0,0,0-2.505,0,1.715,1.715,0,0,0-.307.414h0L2.2,17.781v0a1.727,1.727,0,0,0-.246.535,1.769,1.769,0,0,0,1.764,2.229l13.707,0h0a1.77,1.77,0,0,0,1.636-2.7Zm-7.64.057a1.2,1.2,0,0,1-1.661,0,1.072,1.072,0,0,1-.354-.8,1.087,1.087,0,0,1,.354-.807,1.182,1.182,0,0,1,1.661,0,1.086,1.086,0,0,1,.354.807A1.07,1.07,0,0,1,11.426,17.9Zm.283-6.941c-.059.278-.136.6-.226.977-.086.352-.187.792-.3,1.32s-.229,1.178-.354,1.953h-.475q-.185-1.175-.355-1.958t-.3-1.311c-.079-.323-.15-.639-.216-.951a3.652,3.652,0,0,1-.1-.7,1.076,1.076,0,0,1,.351-.808,1.237,1.237,0,0,1,1.693,0,1.067,1.067,0,0,1,.362.808A3.393,3.393,0,0,1,11.709,10.963Z"
              transform="translate(-1.898 -4.978)"
            />
          </svg>
          <span
            v-if="errors.nonprofitName !== ''"
            class="right-0 absolute mr-1 text-red text-xxs capitalize text-right block w-full"
            >{{ errors.nonprofitName }}
          </span>
        </div>
      </div>
      <div class="flex flex-col items-start w-1/2">
        <div class="flex gap-3 justify-center mb-2">
          <label class="text-gray">Profile Page Name: </label>
          <button
            v-show="!showProfilePageNameField"
            class="text-blue"
            @click="toggleShowProfilePageNameField"
            >Edit</button
          >
          <button
            v-show="showProfilePageNameField"
            class="text-blue"
            @click="saveProfilePageField"
            >Save</button
          >
        </div>
        <span
          v-show="!showProfilePageNameField"
          class="text-left font-semibold"
          >{{ profilePageName === '' ? 'Profile Name' : profilePageName }}</span
        >
        <div v-show="showProfilePageNameField" class="w-full relative">
          <input
            v-model="profilePageName"
            type="text"
            name="profile-page-name"
            placeholder="Profile Page Name"
            class="input"
            :class="[errors.profilePageName !== '' ? 'border-red' : '']"
            @input="clearSubmitErrors('profilePageName')"
          />
          <svg
            v-if="errors.profilePageName !== ''"
            class="absolute right-0 top-0 mr-3 mt-2.5"
            xmlns="http://www.w3.org/2000/svg"
            width="17.433"
            height="15.57"
            viewBox="0 0 17.433 15.57"
          >
            <path
              class="a"
              fill="red"
              d="M19.066,17.847,12.211,5.978h0a1.808,1.808,0,0,0-.342-.483,1.772,1.772,0,0,0-2.505,0,1.715,1.715,0,0,0-.307.414h0L2.2,17.781v0a1.727,1.727,0,0,0-.246.535,1.769,1.769,0,0,0,1.764,2.229l13.707,0h0a1.77,1.77,0,0,0,1.636-2.7Zm-7.64.057a1.2,1.2,0,0,1-1.661,0,1.072,1.072,0,0,1-.354-.8,1.087,1.087,0,0,1,.354-.807,1.182,1.182,0,0,1,1.661,0,1.086,1.086,0,0,1,.354.807A1.07,1.07,0,0,1,11.426,17.9Zm.283-6.941c-.059.278-.136.6-.226.977-.086.352-.187.792-.3,1.32s-.229,1.178-.354,1.953h-.475q-.185-1.175-.355-1.958t-.3-1.311c-.079-.323-.15-.639-.216-.951a3.652,3.652,0,0,1-.1-.7,1.076,1.076,0,0,1,.351-.808,1.237,1.237,0,0,1,1.693,0,1.067,1.067,0,0,1,.362.808A3.393,3.393,0,0,1,11.709,10.963Z"
              transform="translate(-1.898 -4.978)"
            />
          </svg>
          <span
            v-if="errors.profilePageName !== ''"
            class="right-0 absolute mr-1 text-red text-xxs capitalize text-right block w-full"
            >{{ errors.profilePageName }}
          </span>
        </div>
      </div>
    </div>
    <div class="flex -mx-2 mt-8 gap-10 text-left">
      <div class="flex flex-col items-start w-1/2">
        <div class="flex gap-3 justify-center mb-2">
          <label class="text-gray">Main Website: </label>
          <button
            v-show="!showMainWebsiteField"
            class="text-blue"
            @click="toggleShowMainWebsiteField"
            >Edit</button
          >
          <button
            v-show="showMainWebsiteField"
            class="text-blue"
            @click="saveMainWebsiteField"
            >Save</button
          >
        </div>
        <span v-show="!showMainWebsiteField" class="text-left font-semibold">{{
          mainWebsite === '' ? 'www.organization.com' : mainWebsite
        }}</span>
        <div v-show="showMainWebsiteField" class="w-full relative">
          <input
            v-model="mainWebsite"
            type="text"
            name="main-website"
            placeholder="Main Webiste"
            class="input"
            :class="[errors.mainWebsite !== '' ? 'border-red' : '']"
            @input="clearSubmitErrors('mainWebsite')"
          />
          <svg
            v-if="errors.mainWebsite !== ''"
            class="absolute right-0 top-0 mr-3 mt-2.5"
            xmlns="http://www.w3.org/2000/svg"
            width="17.433"
            height="15.57"
            viewBox="0 0 17.433 15.57"
          >
            <path
              class="a"
              fill="red"
              d="M19.066,17.847,12.211,5.978h0a1.808,1.808,0,0,0-.342-.483,1.772,1.772,0,0,0-2.505,0,1.715,1.715,0,0,0-.307.414h0L2.2,17.781v0a1.727,1.727,0,0,0-.246.535,1.769,1.769,0,0,0,1.764,2.229l13.707,0h0a1.77,1.77,0,0,0,1.636-2.7Zm-7.64.057a1.2,1.2,0,0,1-1.661,0,1.072,1.072,0,0,1-.354-.8,1.087,1.087,0,0,1,.354-.807,1.182,1.182,0,0,1,1.661,0,1.086,1.086,0,0,1,.354.807A1.07,1.07,0,0,1,11.426,17.9Zm.283-6.941c-.059.278-.136.6-.226.977-.086.352-.187.792-.3,1.32s-.229,1.178-.354,1.953h-.475q-.185-1.175-.355-1.958t-.3-1.311c-.079-.323-.15-.639-.216-.951a3.652,3.652,0,0,1-.1-.7,1.076,1.076,0,0,1,.351-.808,1.237,1.237,0,0,1,1.693,0,1.067,1.067,0,0,1,.362.808A3.393,3.393,0,0,1,11.709,10.963Z"
              transform="translate(-1.898 -4.978)"
            />
          </svg>
          <span
            v-if="errors.mainWebsite !== ''"
            class="right-0 absolute mr-1 text-red text-xxs capitalize text-right block w-full"
            >{{ errors.mainWebsite }}
          </span>
        </div>
      </div>
      <div class="flex flex-col items-start w-1/2">
        <div class="flex gap-3 justify-center mb-2">
          <label class="text-gray">Volunteer Website: </label>
          <button
            v-show="!showVolunteerWebsiteField"
            class="text-blue"
            @click="toggleShowVolunteerWebsiteField"
            >Edit</button
          >
          <button
            v-show="showVolunteerWebsiteField"
            class="text-blue"
            @click="saveVolunteerWebsiteField"
            >Save</button
          >
        </div>
        <span
          v-show="!showVolunteerWebsiteField"
          class="text-left font-semibold"
          >{{
            volunteerWebsite === ''
              ? 'www.volunteerorganization.com'
              : volunteerWebsite
          }}</span
        >
        <div v-show="showVolunteerWebsiteField" class="w-full relative">
          <input
            v-model="volunteerWebsite"
            type="text"
            name="volunteer-website"
            placeholder="Volunteer Website"
            class="input"
            :class="[errors.volunteerWebsite !== '' ? 'border-red' : '']"
            @input="clearSubmitErrors('volunteerWebsite')"
          />
          <svg
            v-if="errors.volunteerWebsite !== ''"
            class="absolute right-0 top-0 mr-3 mt-2.5"
            xmlns="http://www.w3.org/2000/svg"
            width="17.433"
            height="15.57"
            viewBox="0 0 17.433 15.57"
          >
            <path
              class="a"
              fill="red"
              d="M19.066,17.847,12.211,5.978h0a1.808,1.808,0,0,0-.342-.483,1.772,1.772,0,0,0-2.505,0,1.715,1.715,0,0,0-.307.414h0L2.2,17.781v0a1.727,1.727,0,0,0-.246.535,1.769,1.769,0,0,0,1.764,2.229l13.707,0h0a1.77,1.77,0,0,0,1.636-2.7Zm-7.64.057a1.2,1.2,0,0,1-1.661,0,1.072,1.072,0,0,1-.354-.8,1.087,1.087,0,0,1,.354-.807,1.182,1.182,0,0,1,1.661,0,1.086,1.086,0,0,1,.354.807A1.07,1.07,0,0,1,11.426,17.9Zm.283-6.941c-.059.278-.136.6-.226.977-.086.352-.187.792-.3,1.32s-.229,1.178-.354,1.953h-.475q-.185-1.175-.355-1.958t-.3-1.311c-.079-.323-.15-.639-.216-.951a3.652,3.652,0,0,1-.1-.7,1.076,1.076,0,0,1,.351-.808,1.237,1.237,0,0,1,1.693,0,1.067,1.067,0,0,1,.362.808A3.393,3.393,0,0,1,11.709,10.963Z"
              transform="translate(-1.898 -4.978)"
            />
          </svg>
          <span
            v-if="errors.volunteerWebsite !== ''"
            class="right-0 absolute mr-1 text-red text-xxs capitalize text-right block w-full"
            >{{ errors.volunteerWebsite }}
          </span>
        </div>
      </div>
    </div>
    <div class="-mx-2 mt-8 text-left">
      <div class="flex flex-col items-start">
        <div class="flex gap-3 justify-center mb-2">
          <label class="text-gray">Mission Statement: </label>
          <button
            v-show="!showMissionStatementField"
            class="text-blue"
            @click="toggleShowMissionStatementField"
            >Edit</button
          >
          <button
            v-show="showMissionStatementField"
            class="text-blue"
            @click="saveMissionStatementField"
            >Save</button
          >
        </div>
        <p
          v-show="!showMissionStatementField"
          class="text-left w-0 min-w-full font-semibold wrap-break-word"
          >{{
            missionStatement === ''
              ? 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. . '
              : missionStatement
          }}</p
        >
        <div v-show="showMissionStatementField" class="w-full relative">
          <textarea
            id="mission-statement"
            v-model="missionStatement"
            name="mission-statement"
            class="input resize-none"
            rows="5"
            cols="33"
            :class="[errors.missionStatement !== '' ? 'border-red' : '']"
            @input="clearSubmitErrors('missionStatement')"
          >
          </textarea>
          <span
            v-if="errors.missionStatement !== ''"
            class="right-0 absolute mr-1 text-red text-xxs capitalize text-right block w-full"
            >{{ errors.missionStatement }}
          </span>
        </div>
      </div>
    </div>
    <div class="-mx-2 mt-8 text-left">
      <div class="flex flex-col items-start">
        <label class="text-gray mb-2" for="cause-area">Cause Area: </label>
        <div class="w-1/2 pr-4 relative">
          <select
            id="cause-area"
            v-model="causeId"
            name="cause-area"
            class="select text-gray"
            :class="[errors.causeId !== '' ? 'border-red' : '']"
            :disabled="loadingCauses"
            @input="clearSubmitErrors('causeId')"
          >
            <option class="text-gray" value="" disabled selected>
              {{ loadingCauses ? 'Loading causes...' : 'Choose Below' }}
            </option>
            <option
              v-for="cause in causes"
              :key="cause.id"
              :value="cause.id"
              class="text-gray"
            >
              {{ cause.name }}
            </option>
          </select>
          <span
            v-if="errors.causeId !== ''"
            class="right-0 absolute mr-5 text-red text-xxs capitalize text-right block w-full"
            >{{ errors.causeId }}
          </span>
        </div>
      </div>
    </div>
    <div class="flex -mx-2 mt-8 gap-8 text-left">
      <div class="flex flex-col items-start w-1/3">
        <label class="text-gray mb-2">City: </label>
        <div class="w-full relative">
          <input
            v-model="city"
            type="text"
            name="city"
            placeholder="City"
            class="input pr-0"
            :class="[errors.city !== '' ? 'border-red' : '']"
            @input="clearSubmitErrors('city')"
          />
          <svg
            v-if="errors.city !== ''"
            class="absolute right-0 top-0 mr-3 mt-2.5"
            xmlns="http://www.w3.org/2000/svg"
            width="17.433"
            height="15.57"
            viewBox="0 0 17.433 15.57"
          >
            <path
              class="a"
              fill="red"
              d="M19.066,17.847,12.211,5.978h0a1.808,1.808,0,0,0-.342-.483,1.772,1.772,0,0,0-2.505,0,1.715,1.715,0,0,0-.307.414h0L2.2,17.781v0a1.727,1.727,0,0,0-.246.535,1.769,1.769,0,0,0,1.764,2.229l13.707,0h0a1.77,1.77,0,0,0,1.636-2.7Zm-7.64.057a1.2,1.2,0,0,1-1.661,0,1.072,1.072,0,0,1-.354-.8,1.087,1.087,0,0,1,.354-.807,1.182,1.182,0,0,1,1.661,0,1.086,1.086,0,0,1,.354.807A1.07,1.07,0,0,1,11.426,17.9Zm.283-6.941c-.059.278-.136.6-.226.977-.086.352-.187.792-.3,1.32s-.229,1.178-.354,1.953h-.475q-.185-1.175-.355-1.958t-.3-1.311c-.079-.323-.15-.639-.216-.951a3.652,3.652,0,0,1-.1-.7,1.076,1.076,0,0,1,.351-.808,1.237,1.237,0,0,1,1.693,0,1.067,1.067,0,0,1,.362.808A3.393,3.393,0,0,1,11.709,10.963Z"
              transform="translate(-1.898 -4.978)"
            />
          </svg>
          <span
            v-if="errors.city !== ''"
            class="right-0 mr-1 absolute text-red text-xxs capitalize text-right block w-full"
            >{{ errors.city }}
          </span>
        </div>
      </div>
      <div class="flex flex-col items-start w-1/3">
        <label class="text-gray mb-2" for="state">State: </label>
        <div class="w-full relative">
          <select
            id="state"
            v-model="state"
            name="state"
            class="select text-gray"
            :class="[errors.state !== '' ? 'border-red' : '']"
            @input="clearSubmitErrors('state')"
          >
            <option class="text-gray" value="" disabled selected
              >Choose Below</option
            >
            <option
              v-for="stateItem in states"
              :key="stateItem.code"
              :value="stateItem.code"
              class="text-gray"
            >
              {{ stateItem.name }}
            </option>
          </select>
          <span
            v-if="errors.state !== ''"
            class="right-0 absolute mr-1 text-red text-xxs capitalize text-right block w-full"
            >{{ errors.state }}
          </span>
        </div>
      </div>
      <div class="flex flex-col items-start w-1/3">
        <label class="text-gray mb-2">Zip: </label>
        <div class="relative">
          <input
            v-model="zip"
            type="text"
            name="zip"
            placeholder="Zip"
            class="input pr-0"
            :class="[errors.zip !== '' ? 'border-red' : '']"
            @input="clearSubmitErrors('zip')"
          />
          <svg
            v-if="errors.zip !== ''"
            class="absolute right-0 top-0 mr-3 mt-2.5"
            xmlns="http://www.w3.org/2000/svg"
            width="17.433"
            height="15.57"
            viewBox="0 0 17.433 15.57"
          >
            <path
              class="a"
              fill="red"
              d="M19.066,17.847,12.211,5.978h0a1.808,1.808,0,0,0-.342-.483,1.772,1.772,0,0,0-2.505,0,1.715,1.715,0,0,0-.307.414h0L2.2,17.781v0a1.727,1.727,0,0,0-.246.535,1.769,1.769,0,0,0,1.764,2.229l13.707,0h0a1.77,1.77,0,0,0,1.636-2.7Zm-7.64.057a1.2,1.2,0,0,1-1.661,0,1.072,1.072,0,0,1-.354-.8,1.087,1.087,0,0,1,.354-.807,1.182,1.182,0,0,1,1.661,0,1.086,1.086,0,0,1,.354.807A1.07,1.07,0,0,1,11.426,17.9Zm.283-6.941c-.059.278-.136.6-.226.977-.086.352-.187.792-.3,1.32s-.229,1.178-.354,1.953h-.475q-.185-1.175-.355-1.958t-.3-1.311c-.079-.323-.15-.639-.216-.951a3.652,3.652,0,0,1-.1-.7,1.076,1.076,0,0,1,.351-.808,1.237,1.237,0,0,1,1.693,0,1.067,1.067,0,0,1,.362.808A3.393,3.393,0,0,1,11.709,10.963Z"
              transform="translate(-1.898 -4.978)"
            />
          </svg>
          <span
            v-if="errors.zip !== ''"
            class="right-0 absolute mr-1 text-red text-xxs capitalize text-right block w-full"
            >{{ errors.zip }}
          </span>
        </div>
      </div>
    </div>
    <div class="pl-2 pr-4 mt-8 mb-4">
      <button
        class="primary-button"
        :disabled="isTryingToSetupInfoOrganization"
        @click="submitInfoForm"
        ><span v-if="isTryingToSetupInfoOrganization">Loading</span
        ><span v-if="!isTryingToSetupInfoOrganization">Next</span></button
      >
    </div>
  </div>
</template>
